export const en = {
  accept: 'accept',
  RDI: 'RDI',
  percent: 'percent',
  pageNotFoundTitle: '404 - Page Not Found',
  pageNotFoundDesc: 'The page you are looking for does not exist.',
  contactAdminMessage: 'Contact us if you think there is a problem.',
  age: 'age',
  spontaneous: 'spontaneous',
  userManual: 'User manual',
  AHI: 'AHI',
  about: 'about',
  for: 'for',
  phone: 'phone',
  email: 'email',
  website: 'website',
  delete: 'Delete',
  remove: 'Remove',
  removeAll: 'Remove all',
  removeAllEventsTitle: 'Remove all events?',
  removeAllEventsDescription: 'Are you sure you want to remove all events of type {eventType}?',
  deviceInformation: 'device information',
  releaseDate: 'release date',
  deviceInfoAppliesTo: 'Applies to Onera SleepMap version 1.5.0',
  udi: 'UDI',
  deviceInfoDescription:
    'Onera SleepMap is a software-only medical device that provides automated event detection for Onera polysomnography recordings.',
  close: 'close',
  eventStart: 'event start',
  resourceNotAvailable: 'Resource not available',
  oneStudyAtATimeError: 'You can only open 1 sleep study at a time',
  alreadyOpenedByUserError: 'This sleep study is already opened by another user',
  studyRightsError: 'You do not have rights to open this sleep study',
  fetchErrorDescription: 'Error fetching help URL',
  manualErrorDescription: 'Cannot open manual',
  medDeviceInfo: 'medical device information',
  durationMin: 'Duration (min)',
  durationMinInTST: 'Duration (min in TST)',
  seconds: ' s',
  duration: 'duration',
  time: 'Time',
  manualError: 'manualError',
  fetchError: 'Error fetching',
  eventType: 'Event Type',
  amountOfSnoringPeriods: 'Amount of snoring periods',
  analysisSoftware: 'SleepMap',
  apnea: 'apnea',
  studyInformation: 'Study Information',
  studyInformationNote: 'Chest sensor potentially worn upside down',
  purpose: 'Purpose',
  studyConfiguration: 'Study Configuration',
  patientInfo: 'Patient Information',
  attention: 'Attention',
  desaturationPanelLabel: 'The {desaturation}% rule was applied',
  browserWarning: {
    versionTitle: 'Browser is not supported',
    versionDescription:
      'Please use Edge or Chrome as your browser and make sure their version is not older than 6 months.',
    resolutionTitle: 'Browser resolution is not supported',
    resolutionDesctiption:
      'Please use the highest available screen resolution. \n\n Note that SleepMap requires High Definition (HD) resolution to function properly.'
  },
  analysisService: 'SleepMap',
  obstructiveApnea: 'Obstructive Apnea',
  shortApneaCentral: 'A.Central',
  shortApneaObstructive: 'A.Obstructive',
  shortApneaMixed: 'A.Mixed',
  centralApnea: 'Central Apnea',
  mixedApnea: 'Mixed Apnea',
  obstructiveHypopnea: 'Obstructive Hypopnea',
  centralHypopnea: 'Central Hypopnea',
  apneaAndHypopnea: 'Apnea and Hypopnea',
  apneaLimit:
    'Apneas, Hypopneas, Cheyne Stokes Breathing and RERAs events must be at least 10s long',
  apply: 'apply',
  arousal: 'Arousal',
  recordingTime: 'Recording Time',
  arousals: 'Arousals',
  arousalLimit: 'Arousal must be at least 3s long',
  inWakeStageWarning:
    'You cannot create or modify this type of event during the wake stages of sleep.',
  hasRespiratoryEventTitle: 'A respiratory event exists in this sleep stage.',
  hasRespiratoryEventWarning: 'Respiratory events are highlighted in grey.',
  approvedDescription: 'Are you sure you want to set the status to <strong>Approved</strong>?',
  arousalTRT: 'Arousal TRT',
  rule: 'rule',
  csb: 'CSB',
  trt: 'TRT',
  n1: 'N1',
  n2: 'N2',
  n3: 'N3',
  asterixRespiratory:
    '* Respiratory analysis of hypopneas occurs according to the AASM Manual for Scoring of Sleep and Associated Events 3.0 (released 2023) using the ',
  automaticScoreIsDone: 'Automatic scoring is done',
  automaticScoreSummary: 'automatic score summary',
  band: 'band',
  birthDate: 'birth date',
  bmi: 'BMI',
  cancel: 'cancel',
  cardiacSummary: 'Cardiac Summary',
  central: 'central',
  odiDesatHour: 'ODI (desats/hour)',
  durationinMinutes: 'Duration (min)',
  spO2Quality: 'SpO2 Quality',
  sound_spl: 'sound SPL',
  heart_rate: 'heart rate',
  spO2SupineQuality: 'SpO2 Supine Quality',
  spO2Supine: 'SpO2 Supine',
  epochsStaged: '% epochs staged',
  nasalPressure: 'Nasal Pressure',
  changeHistory: 'Change History',
  count: 'count',
  minutes: 'minutes',
  countEventsInTST: 'Count events (in TST)',
  connectionLostTitle: 'Connection lost',
  desaturationIndexEvtsH: 'Desaturation Index (Evts/H)',
  desaturationIndexODI: 'Desaturation Index (ODI)',
  desaturationsDuration: 'Desaturations Duration',
  evtsPerHour: 'Evts/H',
  minAbbr: 'Min',
  connectionLostDescription:
    'We were unable to reach the server. Please check your internet connection. The system will attempt to reconnect automatically.',
  seeGraphs: 'See Graphs',
  seeReport: 'See Report',
  seeOverview: 'See Overview',
  changeSignalOrder: 'Change signal order',
  changeVisibility: 'Show/hide signal',
  openColorPalette: 'Open color palette',
  openShortcutPicker: 'Set shortcut key',
  pressAnyKey: 'Press a key',
  clearShortcut: 'Clear shortcut',
  shortcutReserved: 'Reserved for sleep staging',
  shortcutAlreadyAssigned: 'Already assigned to {event}',
  analysisStart: 'Analysis start',
  analysisStop: 'Analysis stop',
  navigateToStudyDetail: 'Navigate to study detail',
  remLatency: 'REM Latency',
  invalidHour: 'invalid hour',
  dataIntegrity: 'data integrity',
  desaturation: 'desaturation',
  desaturationDrop: 'Desaturation Drop',
  desaturationEvents: 'Desaturation Events',
  deviceSerialNumber: 'device serial number',
  downloadDraftReport: 'download draft report',
  downloadReport: 'download report',
  spo2Mean: 'SpO2 mean',
  spo2Min: 'SpO2 min',
  cloneScoreSet: 'Clone score set',
  cloneFail: 'Clone failed',
  cloneScoreSuccess: 'Score set cloned successfully',
  allEpochsLoaded: 'Signals for all time windows are loaded',
  epochsLoaded: 'All {epochSize}s epochs data loaded',
  method: 'Method',
  investigationType: 'Investigation Type',
  signalQualitySummary: 'Signal Quality',
  errorAddScoreSetEvents: 'Error adding event',
  errorAuthorization:
    'You are not authorized to view this study. Please contact support if you think this is an error.',
  errorAddScoreSetEvent: 'Error adding event',
  errorDeleteScoreSetEvent: 'Error deleting event',
  errorGeneratingDraftReport: 'Error generating the Draft Report',
  errorGeneratingReport: 'Error generating the Report',
  errorGetHypnogramEvents: 'Error getting the Hypnogram',
  errorGetLegMovementEvents: 'Error getting the Leg Movement',
  errorGetReport: 'Error getting the Report',
  errorGetScoreSet: 'Error loading study',
  errorGetScoreSetEvents: 'Error loading study events',
  errorGetReleaseNotes: 'Error loading release notes',
  errorAcknowledgeReleaseNotes: 'Error confirming release notes',
  errorGetScoreSets: 'Error loading study',
  errorGetSignalData: 'Error loading signals',
  errorGetStudies: 'Error getting the Studies',
  errorGetStudy: 'Error getting the Study',
  errorSettingFullNightSignals: 'Error loading full night signals',
  errorSettingFullNightSignalsMessage:
    'You can select up to 4 signals to view them for the full night!',
  errorUpdateScoreSet: 'Error updating study',
  errorUpdateScoreSetEvent: 'Error updating event',
  errorUpdateUser: 'Error updating user',
  genericAccessError: 'Access is not allowed',
  genericAccessErrorPreparingDescription:
    'You cannot access this resource while the study is in the PREPARING state.',
  firstName: 'first name',
  warningEventLimit: 'Please wait until the other event changes are applied',
  warningEventLimitDescription: 'You have added or updated 20 events consecutively.',
  frontalEEGElectrodes: 'Frontal EEG Electrodes',
  fullNightSignals: 'full night signals',
  selectSignals: 'Select Signals',
  fullSignal: 'full signal',
  name: 'Name',
  dateOfBirth: 'Date of birth',
  patientID: 'Patient ID',
  studyID: 'Study ID',
  unitSystem: 'Unit System',
  METRIC: 'Metric',
  IMPERIAL: 'Imperial',
  errorOverlapLimitDescription:
    'The event overlaps with too many existing events. Please try it with fewer events.',
  reportProgressBar: {
    header: 'One moment please',
    description: 'Preparing sleep report ...'
  },
  gender: 'gender',
  Arrhythmia: 'Arrhythmia',
  'Sinus Tachycardia': 'Sinus Tachycardia',
  'Sinus Bradycardia': 'Sinus Bradycardia',
  arrhythmias: 'Arrhythmias',
  arrhythmiaSummary: 'Arrhythmia Summary',
  atrialFibrillation: 'Atrial fibrillation',
  narrowComplexTachycardia: 'Narrow complex tachycardia',
  wideComplexTachycardia: 'Wide complex tachycardia',
  keyHr: 'Key HR',
  timeInMin: 'Time in (min)',
  avgHrLabel: 'Avg:',
  highestHrLabel: 'Highest:',
  avBlocks: 'AV blocks',
  pacemakerRhythm: 'Pacemaker Rythm',
  asystole: 'Asystole',
  otherIrregularBeats: 'Other Irregular Beats',
  pvcs: 'PVCs',
  pacs: 'PACs',
  longestPause: 'Longest Pause',
  bruxism: 'Bruxism',
  bruxismSummary: 'Bruxism Summary',
  phasic: 'Phasic',
  tonic: 'Tonic',
  bruxismType: 'Type',
  percentTotal: '% total',
  avgDurSec: 'Avg dur (sec)',
  minDurSec: 'Min dur (sec)',
  maxDurSec: 'Max dur (sec)',
  totalTimeMin: 'Total time (min)',
  arrhythmiaEvents: 'Arrhythmia Events',
  arrhythmiaLimit:
    'Asystole, Narrow Complex Tachycardia, and Wide Complex Tachycardia events must be at least 3s long',
  arrhythmiaLayoutWarning: 'This is a new layout compared to the stored Technical Report PDF',
  'Atrial Fibrillation': 'Atrial Fibrillation',
  PAC: 'PAC',
  PVC: 'PVC',
  AV_Block: 'AV-Block',
  'Pacemaker Rhythm': 'Pacemaker Rhythm',
  'Other Arrhythmia': 'Other Arrhythmia',
  Asystole: 'Asystole',
  'Narrow Complex Tachycardia': 'Narrow Complex Tachycardia',
  'Wide Complex Tachycardia': 'Wide Complex Tachycardia',
  generateDraftReport: 'generate draft report',
  generateReport: 'generate report',
  heartRateMean: 'heart rate mean',
  heartRateMax: 'heart rate max',
  heartRateSummary: 'Heart rate summary',
  hrDistributionDuringSleep: 'HR distribution during sleep',
  cardiacEvents: 'Cardiac events',
  sinusBradycardia: 'Sinus bradycardia',
  sinusTachycardia: 'Sinus tachycardia',
  lowestHrLabel: 'Lowest:',
  event: 'Event',
  indexInSleepEvtsH: 'Index in Sleep (Evts/H)',
  height: 'height',
  bpm: 'BPM',
  home: 'home',
  hypopnea: 'hypopnea',
  index: 'index',
  indexOfEventsPerHour: 'Index (events / hour)',
  HR: 'HR',
  hideSignal: 'Hide signal',
  indexOfHR: 'Index of HR',
  inReview: 'in review',
  inReviewDescription: 'Are you sure you want to set the status to <strong>In Review</strong>?',
  lastName: 'last name',
  left: 'left',
  cardiacEventLimit: 'Tachycardia and Bradycardia events must be at least 30s long',
  legMovementLimit: 'Leg movements must be between 0.5s and 10s long',
  legSensorPosition: 'leg sensor position',
  lightsLimit: 'An event cannot start before lights-off timestamp and cannot end after lights-on',
  lightsOff: 'lights off',
  lightsOn: 'lights on',
  loading: 'loading',
  maximum: 'maximum',
  max: 'max',
  mean: 'mean',
  rem: 'REM',
  nrem: 'NREM',
  measurementEnd: 'measurement end',
  measurementStart: 'measurement start',
  spontaneus: 'Spontaneus',
  mild: 'mild',
  minimum: 'minimum',
  mixed: 'mixed',
  moderate: 'moderate',
  movementEvents: 'movement events',
  movementPosition: 'Movement and Position',
  no: 'no',
  noData: 'No Data is available!',
  ok: 'OK',
  notch: 'notch',
  lowCutTooltip: 'Low cut / high-pass',
  highCutTooltip: 'High cut / low-pass',
  note: 'Note',
  sleepStudyRequestNote: 'Sleep study request note',
  notUsed: 'not used',
  normal: 'normal',
  number: 'number',
  numberOfEpisodes: 'The number of episodes',
  obstructive: 'obstructive',
  oxygen: 'oxygen',
  oxygenSummary: 'Oxygen Summary',
  eventsDurationFetchError: 'Error getting chart data',
  eventsDurationFetchErrorDescription: 'Error getting events on events duration graph',
  foreignPatientId: 'Patient ID',
  patientId: 'Patient ID',
  patientApplied: 'patient applied',
  percentage: 'percentage',
  percentageOfSleepTime: '% of sleep time',
  percentageTimeBetween: '% time between',
  percentOfTST: 'Percent of TST',
  percentTST: '% TST',
  physician: 'physician',
  waso: 'WASO',
  physicianNote: 'Physician Note',
  physicianResult: 'physician result',
  physicianReview: 'physician review',
  PLM: 'PLM',
  plms: 'PLMS',
  plmsIndex: 'PLM index',
  CPAP: 'PAP',
  MRA: 'MAD',
  Implant: 'HNS',
  'Positional Device': 'Positional Device',
  Medication: 'Medication',
  Other: 'Other',
  'Insomnia Disorder': 'Insomnia Disorder',
  OSA: 'OSA',
  Narcolepsy: 'Narcolepsy',
  RLS: 'RLS',
  'Circadian Rhythm Sleep-Wake Disorders': 'Circadian Rhythm Sleep-Wake Disorders',
  Diagnostic: 'Diagnostic',
  TherapyControl: 'Therapy Monitoring',
  Unknown: 'Unknown',
  emgLeg: 'EMG Leg',
  ecg: 'ECG',
  nasal_pressure: 'nasal pressure',
  resp_flow: 'resp flow',
  resp_effort: 'resp effort',
  emg_leg: 'EMG Leg',
  activity: 'activity',
  signalWithoutArtifacts: 'Percentage Signal Without Artifacts in Total Recording Time',
  position: 'position',
  artifact: 'Artifact',
  plmsIndexWithArousals: 'PLM index with arousals',
  positionStatistics: 'position statistics',
  preset: 'preset',
  presetName: 'preset name',
  defaultPresetOverwriteTitle: 'Cannot overwrite the default preset',
  defaultPresetOverwriteDescription: 'Please enter a new preset name to save your changes.',
  prone: 'prone',
  psgReport: 'PSG Report',
  recordingEnd: 'recording end',
  recordingStart: 'recording start',
  reject: 'reject',
  report: 'report',
  rejectedDescription: 'Are you sure you want to set the status to <strong>Rejected</strong>?',
  reportPage: 'page {current}/{total}',
  reportPageRef: 'page {page}',
  reportSignedBy: 'report is signed by',
  reportStatus: 'report status: {status}',
  reportVersion: 'T: {template} from M: {mock}',
  RERA: 'RERA',
  invalidDate: 'invalid date',
  rescore: 'rescore',
  upright: 'upright',
  nonsupine: 'nonsupine',
  totalLegMovements: 'Total leg movements',
  respiratoryEventsHourOfTST: 'Respiratory events / hour of TST',
  respiratory: 'respiratory',
  indexOfEvtsPerHour: 'Index (evts/h)',
  respiratoryEvents: 'Respiratory Events',
  respiratoryEventsDuringSleep: 'Respiratory Events During Sleep',
  respiratoryEventsInTST: 'Respiratory Events (in TST)',
  respiratorySummary: 'Respiratory Summary',
  respiratoryParams: 'Respiratory Parameters',
  right: 'right',
  saturation: 'saturation',
  save: 'save',
  saveLaneHeightsDescription:
    'Do you want to save the new signal lane heights to the current preset?',
  saveLaneHeightsTitle: 'Save lane heights?',
  savingNote: 'Save Notes',
  savingNoteDescription: 'Are you sure you want to save the notes?',
  scoring: 'scoring',
  scoringResult: 'scoring result',
  scoringResultSet: 'Setting Scoring Result',
  sectionOxygen: 'oxygen',
  selectPreset: 'select preset',
  settings: 'Settings',
  severe: 'severe',
  signalLaneHeight: 'Signal lane height (px)',
  pinLaneHeight: 'Pin this height',
  unpinLaneHeight: 'Unpin (use auto height)',
  sleep: 'sleep',
  spo2: 'spO2',
  tst: 'TST',
  sleep_stages: 'sleep stages',
  eeg_frontal_l: 'EEG frontal L',
  eeg_frontal_r: 'EEG frontal R',
  eog_l: 'EOG L',
  eog_r: 'EOG R',
  moveForward: 'Move next',
  movePrevious: 'Move previous',
  pause: 'Pause',
  fastBackward: 'Start auto-navigation backward',
  fastForward: 'Start auto-navigation forward',
  emg_mass_l: 'EMG mass L',
  emg_mass_r: 'EMG mass R',
  sensorLikelyWornUpsideDownDescription:
    'Sensor likely worn upside down. Position signals may be incorrect.',
  supine: 'Supine',
  nonSupine: 'Non supine',
  remSupine: 'REM + Supine',
  sleepEfficiency: 'sleep efficiency',
  sleepLatency: 'sleep latency',
  sleepSummary: 'sleep summary',
  snore: 'snore',
  snoreAndCardiac: 'Snore and Cardiac',
  snoringSummary: 'Snoring Summary',
  studyId: 'Study ID',
  warningViewOnlyTitle: 'You are in view-only mode',
  warningViewOnlyDescription:
    'This study is in view-only mode. Some features are restricted and are not available at this time',
  warningEventUpdateBlocked: 'Updating PSG Score Set event restricted',
  warningEventUpdateBlockedDescription:
    'Updating the PSG Score Set event is restricted in this mode',
  warningOverlappingEvents: 'Events overlap not allowed',
  overlappingEventsNotPossible: 'You cannot schedule overlapping events.',
  warningOriginalStudy: 'Trying to edit an original score set',
  successAddScoreSetEvent: 'The PSG Score Set Event was added',
  successDeleteScoreSetEvent: 'The PSG Score Set Event was deleted',
  successUpdateScoreSet: 'The PSG Score Set was updated',
  successUpdateScoreSetEvent: 'The PSG Score Set Event was updated',
  techApplied: 'Technician applied',
  technician: 'technician',
  technicianNote: 'Technician Note',
  technicianResult: 'technician result',
  temporaryReport: 'draft report',
  timeOfSingleSnore: 'Time of single snore',
  total: 'Total',
  periodicLegMovement: 'Periodic leg movement',
  legMovement: 'Leg movement',
  totalAmountOfEvents: 'Total Amount of Events',
  totalLengthOfEvents: 'Total Length of Events',
  totalLengthOfSnoringPeriods: 'Total length of snoring periods',
  totalMeasurementTime: 'total measurement time',
  totalRecording: 'total recording',
  totalTime: 'total time',
  trends: 'Trends',
  unscorable: 'unscorable',
  notApplicable: 'N/A',
  unscorableDescription: 'Are you sure you want to set the status to <strong>Unscorable</strong>?',
  minimumEventDurationLimit: '{eventType} must be at least {duration}s long',
  used: 'used',
  version: 'version',
  wake: 'wake',
  weight: 'weight',
  yes: 'yes',
  increaseZoom: 'Increase Zoom',
  decreaseZoom: 'Decrease Zoom',
  moveUp: 'Move Up',
  moveDown: 'Move Down',
  fitToPane: 'Fit to Pane',
  fitAllToPane: 'Fit All to Pane',
  resetToDefault: 'Reset to default',
  resetAllToDefault: 'Reset all to defaults',
  reset: 'Reset',
  resetLaneHeights: 'Reset signal lane heights',
  overflowSignal: 'Overflow Signal',
  clipSignal: 'Clip Signal',
  overflow: 'Overflow',
  allSignals: 'All',
  noSignals: 'None',
  filters: 'Filters',
  display: 'Display',
  signals: 'Signals',
  sleepStaging: 'Sleep Staging',
  sleepStagingKeysFixed: 'Keys fixed. 30 s view auto-advances.',
  shortcutFixed: 'Fixed — not configurable',
  events: 'Events',
  eventNotFound: 'Event not found',
  missingWidget: 'Missing widget: ',
  durationSec: 'Duration (s)',
  'Apnea Mixed': 'Apnea Mixed',
  'Apnea Central': 'Apnea Central',
  'Apnea Obstructive': 'Apnea Obstructive',
  'Hypopnea Obstructive': 'Hypopnea Obstructive',
  'Hypopnea Central': 'Hypopnea Central',
  'Cheyne-Stokes Breathing': 'Cheyne-Stokes Breathing',
  Snoring: 'Snoring',
  Desaturation: 'Desaturation',
  fourPercentRuleSummary: '4% Rule Summary',
  desaturationRuleSummary: '4% Rule Summary',
  desaturationRuleDescription: 'Based on events meeting a 4% desaturation criteria.',
  'Arousal EEG_frontal_L': 'Arousal',
  'Arousal EEG_frontal_R': 'Arousal',
  'Leg Movement': 'Leg Movement',
  'Periodic Leg Movement': 'Periodic Leg Movement',
  noHypnogramDataTitle: 'There is no data for this hypnogram chart.',
  noScoreSetPlaceholder: 'No score set selected. You are viewing an unscored study.',
  'Apnea Mixed Resp_flow': 'Apnea Mixed',
  'Apnea Central Resp_flow': 'Apnea Central',
  'Apnea Obstructive Resp_flow': 'Apnea Obstructive',
  'Hypopnea Obstructive Resp_flow': 'Hypopnea Obstructive',
  'Hypopnea Central Resp_flow': 'Hypopnea Central',
  'RERA Resp_flow': 'RERA',
  Bruxism_Tonic_L: 'Bruxism Tonic',
  Bruxism_Tonic_R: 'Bruxism Tonic',
  Bruxism_Mix_L: 'Bruxism Mixed',
  Bruxism_Mix_R: 'Bruxism Mixed',
  Bruxism_Phasic_L: 'Bruxism Phasic',
  Bruxism_Phasic_R: 'Bruxism Phasic',
  systemIdentificationInformation:
    'High complexity diagnostic unattended home polysomnography sleep study performed. Recording montage includes EEGx2, EOGx2, EMGx2, ECG with HR, Nasal pressure transducer, chest effort, chest derived airflow, SpO2, body position, snoring microphone, limb EMG, & movement activity measure. The collected data was scored in 30-second epochs according to current American Academy of Sleep Medicine criteria using the {}% rule. \n',
  systemIdentificationInformationTherapyControl:
    'The purpose of the sleep study is to assess the effectiveness of the {} therapy. \n',
  systemIdentificationInformationVersion:
    'The recording was acquired with Onera STS {} and analysed with SleepMap {}',
  unstaged: 'Unstaged',
  reportSection: 'Report Section',
  heartRateBPM: 'Heart rate (BPM)',
  1000: 'Study ID could not be found',
  1001: 'User ID could not be found',
  1002: 'Study ID could not be found',
  1003: 'This sleep study is not opened by any user',
  1004: 'You have to re-open this study',
  1005: 'You already have a different study open',
  1006: 'This study has already been opened by a different user',
  'OCELOT I': 'Onera STS Screener',
  'OCELOT II': 'Onera STS PSG Lite',
  'OCELOT III': 'Onera STS PSG',
  'OCELOT IV': 'Onera STS Screener +',
  'OCELOT V': 'Onera STS PSG Lite +',
  'OCELOT VI': 'Onera STS PSG +',
  'OCELOT VII': 'Onera STS Head',
  'OCELOT VIII': 'Onera STS Leg',
  'OCELOT IX': 'Onera STS Flow',
  'OCELOT X': 'Onera STS PSG+ and PAP',
  C: 'Onera STS Screener',
  HC: 'Onera STS PSG Lite',
  HCLL: 'Onera STS PSG',
  CF: 'Onera STS Screener +',
  HCF: 'Onera STS PSG Lite +',
  HCFLL: 'Onera STS PSG +',
  H: 'Onera STS Head',
  LL: 'Onera STS Leg',
  F: 'Onera STS Flow',
  invertPolarity: 'Invert polarity',
  ODI: 'ODI',
  PLMI: 'PLMI',
  snoring: 'Snoring',
  statTile_sleepLatency: 'Sleep latency',
  statTile_remLatency: 'REM latency',
  statTile_waso: 'WASO',
  statTile_AHI: 'AHI',
  statTile_apneaIndex: 'Apnea index',
  statTile_hypopneaIndex: 'Hypopnea index',
  statTile_minSpO2: 'Min SpO2',
  statTile_meanSpO2: 'Mean SpO2',
  statTile_ODI: 'ODI',
  statTile_arousalIndex: 'Arousal index',
  statTile_PLMI: 'PLMI',
  statTile_snoringDuration: 'Snoring duration',
  statTile_spO2Quality: 'SpO2 quality',
  statTile_positionQuality: 'Position quality',
  statTile_nasalCannula: 'Nasal cannula',
  sleepStagesDistribution_notStaged: 'NS',
  sleepStagesDistribution_totalSleepTime: 'Total sleep time',
  sleepStagesDistribution_tstTib: 'TST / TIB',
  sleepPosition_title: 'Sleep position',
  reviewingTechnicianName: 'Reviewing Technician Name',
  reviewingTechnicianCertifications: 'Certifications',
  technicianName: 'Technician Name',
  technicianCertifications: 'Technician Certifications',
  top: 'Top',
  bottom: 'Bottom',
  preferredView: 'Preferred view',
  preferredView_overview: 'Overview',
  preferredView_report: 'Report',
  preferredView_graphs: 'Graphs',
  viewMode: 'View Mode',
  singleView: 'Single',
  splitScreen: 'Split Screen',
  singleHypnogram: 'Single Hypnogram',
  releaseNotesTitle: "What's new in Onera SleepMap?",
  releaseNotesBrowseTitle: 'Release notes',
  releaseNotesIfuHint: 'Please see the full updated clinician guide in the Help section.',
  releaseNotesReleasedOn: 'Released on {date}',
  releaseNotesGotIt: 'Got it',
  releaseNotesLoadOlder: 'Load older versions',
  releaseNotesSeeMore: 'See more releases'
};
